import React from 'react'

const Test = () => {
  const upiId = "8959225934@ybl"; // UPI ID of recipient
  const payeeName = "rohit";
  const amount = 100; // INR

  const handlePay = () => {
    const upiLink = `upi://pay?pa=${upiId}&pn=${payeeName}&am=${amount}&cu=INR`;

    window.location.href = upiLink;
  };

  return (
    <div>
      <button onClick={handlePay}>Pay ₹{amount} to {payeeName}</button>
    </div>
  );
};

export default Test